<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
			<div class="dp-dept-hint">
				<span class="dp-dept-hint__label">所属机构</span>
				<span class="dp-dept-hint__value">{{ currentDepartmentName || '全部' }}</span>
			</div>
			<div class="all_page_border">
								<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow">

					<el-table-column type="selection"> </el-table-column>

					<el-table-column prop="Title" label="标题" width></el-table-column>
					<el-table-column prop="DepartmentName" label="部门" :formatter="formatDepartmentNameCol" width></el-table-column>
					<el-table-column prop="HonorTypeName" label="荣誉类型" width></el-table-column>
					<el-table-column prop="UserName" label="获奖者" width></el-table-column>
					<el-table-column prop="Level" label="级别" width></el-table-column>
					<el-table-column prop="Awards" label="获奖情况" width="" show-overflow-tooltip></el-table-column>
					<el-table-column prop="IsPublish" label="是否发布" width="">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsPublish == 1 ? 'success' : 'info'" disable-transitions>{{
								scope.row.IsPublish == 1 ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>

					<el-table-column prop="MediaFiles" label="照片" align="center" header-align="center">
						<template slot-scope="scope">
							<oss-media-thumbs :media="scope.row.MediaFiles" thumb-width="70px" />
						</template>
					</el-table-column>
					<el-table-column prop="CreateBy" label="创建人" width>
					</el-table-column>
					<el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime"
						width></el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>
			<!--编辑界面-->
			<el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible"
				:close-on-click-modal="false">
				<el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
					<el-form-item label="标题" prop="Title">
						<el-input v-model="editForm.Title" auto-complete="off"></el-input>
					</el-form-item>

					<el-form-item label="所属机构" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="editForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<!-- 荣誉类型 -->
					<el-form-item label="荣誉类型：" prop="HonorTypeId">
						<el-select v-model="editForm.HonorTypeId" placeholder="[未指定]" style="width: 100%;"
							no-data-text="无数据,请联系管理员添加">
							<el-option v-for="item in honorTypeList" :key="item.Id" :label="item.Name"
								:value="item.Id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="荣誉获奖者" prop="UserId">
						<el-select v-model="editForm.UserId" placeholder="[未指定]" style="width: 100%;" clearable>
							<el-option v-for="item in studentList" :key="item.Id" :label="item.Name"
								:value="item.Id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="级别" prop="Level">
						<el-input v-model="editForm.Level" autocomplete="off" type="number"></el-input>
					</el-form-item>

					<el-form-item label="获奖情况" prop="Awards">
						<el-input type="textarea" :rows="3" v-model="editForm.Awards"
							placeholder="请输入获奖情况描述..."></el-input>
					</el-form-item>

					<el-form-item label="是否发布" prop="IsPublish">
						<el-switch v-model="editForm.IsPublish"></el-switch>
					</el-form-item>

					<el-form-item label="封面">
						<el-upload class="avatar-uploader" action="#" :auto-upload="false"
							:show-file-list="false" :on-change="handleCoverChange">
							<img v-if="deferredImageDisplay('cover', imageUrl)" v-oss-src="deferredImageDisplay('cover', imageUrl)" class="avatar" />
							<i v-if="!deferredImageDisplay('cover', imageUrl)" class="el-icon-plus avatar-uploader-icon"></i>
							<div class="avatar-uploader-tip" v-if="!deferredImageDisplay('cover', imageUrl)">
								请选择10:6的图片
							</div>
						</el-upload>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--新增界面-->
			<el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
				<el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">

					<el-form-item label="荣誉标题" prop="Title">
						<el-input v-model="addForm.Title" auto-complete="off"></el-input>
					</el-form-item>

					<el-form-item label="所属机构" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="addForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"
							@change="deptChange"></el-cascader>
					</el-form-item>

					<!-- 荣誉类型 -->
					<el-form-item label="荣誉类型：" prop="HonorTypeId">
						<el-select v-model="addForm.HonorTypeId" placeholder="[未指定]" style="width: 100%;"
							no-data-text="无数据,请联系管理员添加">
							<el-option v-for="item in honorTypeList" :key="item.Id" :label="item.Name"
								:value="item.Id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="荣誉获奖者" prop="UserId">
						<el-select v-model="addForm.UserId" placeholder="[未指定]" style="width: 100%;" clearable>
							<el-option v-for="item in studentList" :key="item.Id" :label="item.Name"
								:value="item.Id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="级别" prop="Level">
						<el-input v-model="addForm.Level" autocomplete="off" type="number"></el-input>
					</el-form-item>

					<el-form-item label="获奖情况" prop="Awards">
						<el-input type="textarea" :rows="3" v-model="addForm.Awards"
							placeholder="请输入获奖情况描述..."></el-input>
					</el-form-item>

					<el-form-item label="是否发布" prop="IsPublish">
						<el-switch v-model="addForm.IsPublish"></el-switch>
					</el-form-item>

					<el-form-item label="照片">
						<el-upload class="avatar-uploader" action="#" :auto-upload="false"
							:show-file-list="false" :on-change="handleCoverChange">
							<img v-if="deferredImageDisplay('cover', imageUrl)" v-oss-src="deferredImageDisplay('cover', imageUrl)" class="avatar" />
							<i v-if="!deferredImageDisplay('cover', imageUrl)" class="el-icon-plus avatar-uploader-icon"></i>
							<div class="avatar-uploader-tip" v-if="!deferredImageDisplay('cover', imageUrl)">
								请选择10:6的图片
							</div>
						</el-upload>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<el-upload style="display: none;" name="Files" class="quill-upload" :on-success="quillSuccess"
				accept=".png, .jpg, .jpeg" :data="$ossUploadData('HonorList')" :action="BaseApiUrl + '/images/Upload/Pic'">
				<i class="el-icon-upload"></i>
			</el-upload>

		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getHonorTypeListPage, getDeptHonorRecordListPage, editDeptHonorRecord, addDeptHonorRecord, deleteDeptHonorRecord } from '../../api/modules/moral-education';
import deptCascaderSelectionMixin from '../../mixins/deptCascaderSelectionMixin'
import { BaseApiUrl } from '../../api/base';
import { GetStudentSelectListByClassId } from '../../api/modules/personnel';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], // 引用，代码块
	[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], // 列表
	[{ script: 'sub' }, { script: 'super' }], // 上下标
	[{ indent: '-1' }, { indent: '+1' }], // 缩进
	[{ direction: 'rtl' }], // 文本方向
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
	[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
	[{ align: [] }], // 对齐方式
	['clean'], // 清除字体样式
	['image'], // 上传图片
]
export default {
	mixins: [deptCascaderSelectionMixin],
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
			searchList: [
				{
					label: '名称',
					key: 'name',
				},
			],
			imageUrl: '',
			imageLoadding: false,
			editorOption: {
				placeholder: '请在这里输入',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							// 重写点击组件上的图片按钮要执行的代码
							image: function (value) {
								if (value) {
									document.querySelector('.quill-upload .el-icon-upload').click()
								} else {
									this.quill.format("image", false);
								}
							}
						}
					}
				},
			},
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],

				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
				HonorTypeId: [
					{ required: true, message: '请选择荣誉类型', trigger: 'change' }
				],
			},
			//编辑界面数据
			editForm: {
				Id: 0,
				Title: '',
				HonorTypeId: '',
				MediaFiles: '',
				UserId: null,
				UserName: '',
				Level: 1,
				Dids: [],
				DepartmentId: 0,
				IsPublish: true,
				Awards: '',
			},

			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
				HonorTypeId: [
					{ required: true, message: '请选择荣誉类型', trigger: 'change' }
				],
			},
			//新增界面数据
			addForm: {
				Title: '',
				HonorTypeId: '',
				MediaFiles: '',
				UserId: null,
				UserName: '',
				Level: 1,
				Dids: [],
				DepartmentId: 0,
				IsPublish: true,
				Awards: '',
			},
			DepartmentId: 0,
			SchoolId: 0,
			multipleSelection: [],
			studentList: [],
			currentDepartmentName: '',
			honorTypeList: [],
		}
	},
	methods: {
		deptChange(val) {
			// 切换部门只影响获奖者；荣誉类型按学校级，不随部门变化
			let departmentId = null;
			if (Array.isArray(val)) {
				departmentId = val.length > 0 ? val[val.length - 1] : null;
			} else {
				departmentId = val;
			}

			if (departmentId) {
				this.fetchStudentList(departmentId);
			} else {
				this.studentList = [];
			}
		},

		fetchStudentList(val) {
			var para = {
				departmentId: val,
			};
			GetStudentSelectListByClassId(para).then(res => {
				this.studentList = res.data.response || [];
			});
		},

		/** 荣誉类型按顶部学校 ID 查询（学校级配置） */
		fetchHonorTypeList() {
			const schoolId = this.getSchoolIdForDeptCascader();
			if (!schoolId) {
				this.honorTypeList = [];
				return;
			}
			getHonorTypeListPage({ departmentId: schoolId }).then(res => {
				this.honorTypeList = res.data.response || [];
			});
		},
		onEditorBlur() {
			//失去焦点事件
		},
		onEditorFocus() {
			//获得焦点事件
		},
		onEditorChange() {
			//内容改变事件
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			console.log(data)
			this.DepartmentId = data.value
			this.captureDepartmentTreeContext(data, node)
			this.currentDepartmentName = data.label || data.name || ''
			// 向上寻找当前节点所属的学校ID
			let schoolId = 0;
			let tempNode = node;
			while (tempNode) {
				if (tempNode.data && (tempNode.data.DeptOrgType === 'school' || tempNode.data.DeptOrgType === 'affiliateschool')) {
					schoolId = tempNode.data.value;
					break;
				}
				if (tempNode !== node || tempNode.level === 1) {
					if (tempNode.level === 2 || tempNode.level === 1) {
						schoolId = tempNode.data.value;
						break;
					}
				}
				tempNode = tempNode.parent;
			}
			this.SchoolId = schoolId || data.value;
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				departmentId: this.DepartmentId,
			}
			getDeptHonorRecordListPage(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			//NProgress.start();
			getDeptHonorRecordListPage(para).then(async (res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				const rows = res.data.response.data || []
				await this.prefetchListOssMedia(rows, 'MediaFiles')
				this.users = rows
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//显示编辑界面
		handleEdit() {
			var row = this.multipleSelection
			if (row.length == 0 || row.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}
			this.editFormVisible = true
			this.editForm = Object.assign({}, row[0])
			if (this.editForm.Dids) {
				this.$set(this.editForm, 'Dids', this.sanitizeDeptCascaderIds(this.editForm.Dids));
			} else {
				this.$set(this.editForm, 'Dids', []);
			}
			this.imageUrl = this.editForm.MediaFiles
			this.deferredImageInit('cover', this.editForm.MediaFiles)

			this.options = []
			this.initDeptFormSelection('edit', row[0].DepartmentId, row[0].Dids).then((path) => {
				this.applyDeptCascaderPath(this.editForm, path)
			}).catch(() => {})

			this.fetchHonorTypeList();
			this.fetchStudentList(this.editForm.DepartmentId);

		},
		//显示新增界面
		handleAdd() {
			if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
				this.$message.warning("请先在左侧选择具体的学校机构！");
				return;
			}
			this.addForm = {
				Title: '',
				HonorTypeId: '',
				MediaFiles: '',
				UserId: null,
				UserName: '',
				Level: 1,
				Dids: [],
				DepartmentId: 0,
				IsPublish: true,
				Awards: '',
			}
			this.imageUrl = ''
			this.deferredImageRevoke('cover')
			if (!this.getSchoolIdForDeptCascader()) {
				this.$message.warning("请先在顶部切换学校！");
				return;
			}
			this.options = []
			this.studentList = []
			this.honorTypeList = []
			this.fetchHonorTypeList()
			this.initDeptFormSelection('add', this.DepartmentId).then((path) => {
				this.addFormVisible = true
				this.applyDeptCascaderPath(this.addForm, path)
				// 级联赋值不会触发 @change，需主动按所属机构拉取学生
				const departmentId = Array.isArray(path) && path.length > 0
					? path[path.length - 1]
					: this.DepartmentId
				if (departmentId) {
					this.fetchStudentList(departmentId)
				}
			}).catch(() => {})
		},
		handleCoverChange(file) {
			this.deferredImageChange('cover', file, { foo: 'HonorList', savedUrl: this.imageUrl })
		},
		quillSuccess(response) {
			if (response.success) {
				// 获取文本编辑器
				const quill = this.$refs.myQuillEditor.quill
				// 获取光标位置
				const pos = quill.getSelection().index
				// 插入图片到光标位置
				quill.insertEmbed(pos, 'image', this.$resolveImageSrc(response.response))
			} else {
				this.$message({
					message: response.msg,
					type: 'error',
				})
			}
		},
		//编辑
		editSubmit: function () {
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(async () => {
						this.editLoading = true
						//NProgress.start();
						this.editForm.MediaFiles = await this.deferredImageEnsure('cover', { foo: 'HonorList', currentUrl: this.editForm.MediaFiles })

						// ...其他校验...
						if (this.editForm.UserId) {
							const user = this.studentList.find(item => item.Id === this.editForm.UserId);
							console.log(user)
							this.editForm.UserName = user ? user.Name : '';
						} else {
							this.editForm.UserName = '';
						}

						let para = Object.assign({}, this.editForm)
						para.DepartmentId = para.Dids.pop();
						editDeptHonorRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.editLoading = false
								return
							}
							if (res.data.success) {
								this.editLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//新增
		addSubmit: function () {
			let _this = this
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(async () => {
						this.addLoading = true
						//NProgress.start();
						this.addForm.MediaFiles = await this.deferredImageEnsure('cover', { foo: 'HonorList', currentUrl: this.addForm.MediaFiles });

						// ...其他校验...
						if (this.addForm.UserId) {
							const user = this.studentList.find(item => item.Id === this.addForm.UserId);
							this.addForm.UserName = user ? user.Name : '';
						} else {
							this.addForm.UserName = '';
						}

						let para = Object.assign({}, this.addForm)
						para.DepartmentId = para.Dids.pop();


						var user = JSON.parse(window.localStorage.user)
						if (user && user.uID > 0) {
							para.CreateUser = user.uRealName
						} else {
							this.$message({
								message: '用户信息为空，先登录',
								type: 'error',
							})
							_this.$router.replace(
								_this.$route.query.redirect ? _this.$route.query.redirect : '/'
							)
						}

						addDeptHonorRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.addLoading = false
								return
							}

							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})

				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteDeptHonorRecord(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
		// 格式化部门名称：只保留路径的最后两级
		formatDepartmentNameCol(row, column, cellValue) {
			if (!cellValue) return '';
			const parts = cellValue.split('/');
			if (parts.length > 2) {
				return parts.slice(-2).join('/');
			}
			return cellValue;
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}
</style>
